/**
 * Resolve a VIP rank's display label. Returns the operator-defined custom
 * name if non-empty, otherwise falls back to "VIP <n>" for the VIP ladder.
 *
 * @param {object} rank    Rank object from getVipRankDetails with { customDisplayName?, vipRank }
 * @param {string} fallback  Optional label to use when `rank` is missing entirely
 */
export const getVipRankLabel = (rank, fallback) => {
  const custom = rank?.customDisplayName?.trim();
  if (custom) return custom;
  if (rank?.vipRank !== undefined && rank?.vipRank !== null) {
    return `VIP ${rank.vipRank}`;
  }
  return fallback ?? '';
};

/**
 * Look up a rank record by its numeric rank number in the getVipRankDetails
 * response array.
 *
 * @param {Array}  vipRanks    Array from getVipRankDetails result
 * @param {number} rankNumber  Numeric rank (0..N)
 */
export const findRankByNumber = (vipRanks, rankNumber) =>
  (vipRanks || []).find((r) => Number(r.vipRank) === Number(rankNumber));
